export default __webpack_public_path__ + "static/media/mainImage.4e823fcb.png";